import React from 'react';
import { Link } from 'gatsby';
import { Button } from 'semantic-ui-react';

const BackButton = () => (<Button to="/" as={Link} labelPosition="left" icon="left chevron" content="Back to Home" />);

export default BackButton;
